module.exports = __webpack_public_path__ + "img/delivery-courier 2.79f67b0b.svg";